import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {FeedbackService} from "../../service/feedback.service";
import {filter, tap} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {ActivatedRoute, Router} from "@angular/router";
import {Feedback} from "../../repository/entity/feedback.entity";

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent implements OnInit {

  destroyRef = inject(DestroyRef)
  companyCode: string;
  refNum: string;
  feedback: Feedback;
  constructor(
    private _feedbackService: FeedbackService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  ngOnInit(): void {
    const companyCode = this.route.snapshot.paramMap.get('companyCode');
    if (companyCode) {
      this.companyCode = companyCode
    }
    const refNum = this.route.snapshot.paramMap.get('refNum');
    if (refNum) {
      this.refNum = refNum
    }
    if (!companyCode || !refNum) {
      return;
    }
    this._feedbackService.fetchFeedback(companyCode, refNum)
      .pipe(
        tap((feedback) => {
          if (!feedback.feedbackId) {
            this.router.navigate(["../"], {
              relativeTo: this.route
            })
            return;
          }
        }),
        filter((feedback) => {
          return feedback &&  feedback.feedbackId != null && feedback.feedbackId > 0
        }),
        tap((feedback) => {
          this.feedback = feedback
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        error: (err) => {
          if (err.status != 200) {
            this.router.navigate(['404'])
            return
          }
        }
      })
  }

}
